/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ExtendedIncidentsTypesEnumModel,
    IncidentReasonEnum,
    IncidentsTypesEnumModel,
    UnexpectedResetErrorState,
} from './';

/**
 * Datatype for UnexpectedResetError Incident
 * @export
 * @interface UnexpectedResetErrorIncident
 */
export interface UnexpectedResetErrorIncident {
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    resolving_type?: UnexpectedResetErrorIncidentResolvingTypeEnum;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    comment?: string;
    /**
     * @type {Date}
     * @memberof UnexpectedResetErrorIncident
     */
    created_time: Date;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    device_id: string;
    /**
     * @type {IncidentsTypesEnumModel | ExtendedIncidentsTypesEnumModel}
     * @memberof UnexpectedResetErrorIncident
     */
    error_type: IncidentsTypesEnumModel | ExtendedIncidentsTypesEnumModel;
    /**
     * @type {IncidentReasonEnum}
     * @memberof UnexpectedResetErrorIncident
     */
    reason?: IncidentReasonEnum;
    /**
     * @type {number}
     * @memberof UnexpectedResetErrorIncident
     */
    id?: number;
    /**
     * @type {number}
     * @memberof UnexpectedResetErrorIncident
     */
    zone_id?: number;
    /**
     * @type {number}
     * @memberof UnexpectedResetErrorIncident
     */
    group_id?: number;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    zone_name?: string;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    group_name?: string;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    network_id?: string;
    /**
     * @type {boolean}
     * @memberof UnexpectedResetErrorIncident
     */
    damaged_status?: boolean;
    /**
     * @type {boolean}
     * @memberof UnexpectedResetErrorIncident
     */
    activation_status?: boolean;
    /**
     * @type {boolean}
     * @memberof UnexpectedResetErrorIncident
     */
    is_resolved?: boolean;
    /**
     * @type {boolean}
     * @memberof UnexpectedResetErrorIncident
     */
    damaging?: boolean;
    /**
     * @type {Date}
     * @memberof UnexpectedResetErrorIncident
     */
    resolved_time?: Date;
    /**
     * @type {UnexpectedResetErrorState}
     * @memberof UnexpectedResetErrorIncident
     */
    state: UnexpectedResetErrorState;
    /**
     * @type {string}
     * @memberof UnexpectedResetErrorIncident
     */
    user_id?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum UnexpectedResetErrorIncidentResolvingTypeEnum {
    Auto = 'auto',
    Manual = 'manual'
}

